import { render, staticRenderFns } from "./IndexListNew.vue?vue&type=template&id=587e22ae&scoped=true&"
import script from "./IndexListNew.vue?vue&type=script&lang=js&"
export * from "./IndexListNew.vue?vue&type=script&lang=js&"
import style0 from "./IndexListNew.vue?vue&type=style&index=0&id=587e22ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e22ae",
  null
  
)

export default component.exports